import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { BRAND, NAV_LINKS, SERVICES } from "../lib/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#0A0A0A] border-t border-white/10 text-white/70">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-baseline gap-2">
            <span className="font-display-bold text-2xl text-white">REFLEX</span>
            <span className="font-serif-italic text-[#C9A86A] text-lg">stone&nbsp;care</span>
          </div>
          <p className="mt-5 max-w-md text-sm leading-relaxed">
            {BRAND.tagline}. Marble, terrazzo and natural stone restored with
            craftsmanship, precision and obsessive attention to detail.
          </p>
          <div className="mt-8 space-y-3 text-sm">
            <a href={BRAND.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 hover:text-white">
              <Phone className="w-4 h-4 text-[#C9A86A]" /> {BRAND.phone}
            </a>
            <a href={BRAND.emailHref} data-testid="footer-email" className="flex items-center gap-3 hover:text-white">
              <Mail className="w-4 h-4 text-[#C9A86A]" /> {BRAND.email}
            </a>
            <div className="flex items-center gap-3">
              <MapPin className="w-4 h-4 text-[#C9A86A]" /> {BRAND.serviceArea}
            </div>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-[11px] uppercase tracking-[0.25em] text-white mb-5">Navigate</h4>
          <ul className="space-y-3 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-nav-${l.label.toLowerCase()}`} className="hover:text-white">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-[11px] uppercase tracking-[0.25em] text-white mb-5">Services</h4>
          <ul className="space-y-3 text-sm">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.slug}>
                <Link to="/services" className="hover:text-white">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
          <div className="mt-8 flex items-center gap-3">
            <a href="#" className="w-9 h-9 inline-flex items-center justify-center border border-white/15 hover:border-[#C9A86A]" aria-label="Instagram">
              <Instagram className="w-4 h-4" />
            </a>
            <a href="#" className="w-9 h-9 inline-flex items-center justify-center border border-white/15 hover:border-[#C9A86A]" aria-label="Facebook">
              <Facebook className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/45">
          <p>© {new Date().getFullYear()} Reflex Stone Care. All rights reserved.</p>
          <p className="font-serif-italic text-white/60">Crafted in Sydney.</p>
        </div>
      </div>
    </footer>
  );
}
